import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { RelatedProject } from '@app/core/model/entities/project/project';
import { Work } from '@app/core/model/entities/works/work';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';

@Component({
  templateUrl: './work-update-projects-modal.component.html',
  styleUrl: '../../../../../../../shared/components/form-builder/sections/create-modal.component.scss',
  standalone: false
})
export class WorkUpdateProjectsModalComponent implements OnInit, GeneratesObject {

  protected readonly EntityTypeEnum = EntityTypeEnum;

  public workForm: FormGroup<{ project: FormControl<RelatedProject> }>;
  public assetIds: string[] = [];

  protected fb = inject(FormBuilder);
  protected destroyRef = inject(DestroyRef);

  constructor() {
    const works = inject<{ works: Work[] }>(MAT_DIALOG_DATA).works;
    this.assetIds = [...new Set(works.map(work => work.assetId).filter(assetId => !!assetId))];
  }

  /**
   * Fetch possible values for projects.
   */
  public ngOnInit(): void {
    this.workForm = this.fb.group({
      project: this.fb.control(null, Validators.required)
    });
  }

  /**
   * Data from the filled form.
   * @return Work data.
   */
  public getGeneratedObject(): string {
    return this.workForm.controls.project.value.id;
  }
}
